import { render, staticRenderFns } from "./07_LegalBranches.vue?vue&type=template&id=69f2af92&"
import script from "./07_LegalBranches.vue?vue&type=script&lang=js&"
export * from "./07_LegalBranches.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports